// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xc6by","col":"styles_col__11oGM"};